import { getSDKConfig } from '../lib/getSDKConfig';
import { TenantFeature } from '../enums/tenantFeatures';

export const isTenantFeatureEnabled = (features: string[]): boolean => {
  if (!features || features.length === 0) {
    return false;
  }

  const swipeSDKConfig = getSDKConfig();
  const tenantId =
    (swipeSDKConfig.tenantId as string) ||
    (swipeSDKConfig.swipeGames?.gameListConfig?.routeParams
      ?.tenant as string) ||
    '';

  if (!tenantId) {
    return false;
  }

  for (const feature of features) {
    let allowedTenants = '';

    if (feature === TenantFeature.ARROW_ICONS) {
      allowedTenants = process.env.NX_TENANT_ARROW_ICONS || '';
    }

    if (feature === TenantFeature.DRAWER_MENU) {
      allowedTenants = process.env.NX_TENANT_DRAWER_MENU || '';
    }

    if (feature === TenantFeature.DYNAMIC_GRADIENT) {
      allowedTenants = process.env.NX_TENANT_DYNAMIC_GRADIENT || '';
    }

    if (feature === TenantFeature.IFRAME_GRADIENT) {
      allowedTenants = process.env.NX_TENANT_IFRAME_GRADIENT || '';
    }

    if (feature === TenantFeature.SIMULATE_SPECIALS_OTP_IN_URL) {
      allowedTenants = process.env.NX_TENANT_SIMULATE_SPECIALS_OTP_IN_URL || '';
    }

    if (!allowedTenants) {
      return false;
    }

    if (allowedTenants.trim() === '*') {
      continue;
    }

    const tenantList = String(allowedTenants)
      .split(',')
      .map((id) => id.trim())
      .filter((id) => id.length > 0);

    if (!tenantList.includes(tenantId)) {
      return false;
    }
  }

  return true;
};
